<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <!-- HEADER -->
  <app-header-noauth class="appHeader appHeader--sticky appHeader--noauth"></app-header-noauth>
  <!-- BODY -->
  <div class="wrapper wrapper--noauth" fxLayoutAlign="center center" fxFlex="100">
    <div class="wrapper__content" fxFlex="100">
      <mat-card class="release__card" fxFlex="100">
        <mat-card-header>
          <mat-card-title>Comunicado</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <iframe title="releases" [src]="video ? srcUrl : routePdf" width="100%" height="800px"></iframe>
        </mat-card-content>
        <mat-card-actions fxLayoutAlign="center" fxLayoutGap="1rem">
          <button id="acceptButton" mat-flat-button color="accent" (click)="accept()">
            <span translate>matcard.button.aceptar</span>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
  <!-- FOOTER -->
  <app-footer class="appFooter appFooter--noauth"></app-footer>
</div>
